export default "__VITE_ASSET__08f8243f__"